<div mat-dialog-content>
	<mat-radio-group
		[(ngModel)]="result"
		class="flex flex-col"
		(ngModelChange)="returnValue()">
		@for (choice of choices; track choice) {
			<mat-radio-button [value]="choice">
				{{ choice.label }}
			</mat-radio-button>
		}
	</mat-radio-group>
</div>
<div
	mat-dialog-actions
	[align]="'end'">
	<button
		mat-button
		mat-dialog-close>
		{{ "core.cancel" | translate }}
	</button>
</div>
